/**
 * Created by Jonas Wålekvist on 2018-04-05.
 */
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaSound} from "../../sound/KitchenDramaSushiManiaSound";
import {gsap} from "gsap";


export class SymbolTransformAnimation extends PIXI.Container {
    private static SUSHI_TRANSFORM_NAME:string = "sushiTransform";
    private static RING_LAND:string = "ring_land";
    //Symbol Name
    public static SYM_M1:string = "M1_jump"; // Salmon
    public static SYM_M4:string = "M4_jump"; // Rice
    public static SYM_L2:string = "L2_jump"; // Soy

    private _soyContainer:PIXI.Container;
    private _soyJump:TimelineSprite;
    private _soyTransform:TimelineSprite;
    private _soyLand:TimelineSprite;

    private _salmonContainer:PIXI.Container;
    private _salmonJump:TimelineSprite;
    private _salmonTransform:TimelineSprite;
    private _salmonLand:TimelineSprite;

    private _riceContainer:PIXI.Container;
    private _riceJump:TimelineSprite;
    private _riceTransform:TimelineSprite;
    private _riceLand:TimelineSprite;

    constructor() {
        super();
        this.createAnimations();
        this.addChild(this._soyContainer);
        this.addChild(this._riceContainer);
        this.addChild(this._salmonContainer);

        this._soyContainer.position.set(-140, 0);
        this._salmonContainer.position.set(0, 50);
        this._riceContainer.position.set(140, 0);

    }

    private createAnimations() {
        // Soy
        this._soyContainer = new PIXI.Container();

        this._soyJump = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SYM_L2));
        this._soyJump.anchor.set(0.5, 1);
        this._soyJump.hide();


        this._soyTransform = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SUSHI_TRANSFORM_NAME));
        this._soyTransform.anchor.set(0.5, 1);
        this._soyTransform.position.set(-5, 3);
        this._soyTransform.hide();

        this._soyLand = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.RING_LAND));
        this._soyLand.anchor.set(0.5, 1);
        this._soyLand.position.set(5, -2);
        this._soyLand.hide();

        this._soyContainer.addChild(this._soyLand);
        this._soyContainer.addChild(this._soyJump);
        this._soyContainer.addChild(this._soyTransform);


        // Salmon
        this._salmonContainer = new PIXI.Container();

        this._salmonJump = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SYM_M1));
        this._salmonJump.anchor.set(0.5, 1);
        this._salmonJump.hide();

        this._salmonTransform = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SUSHI_TRANSFORM_NAME));
        this._salmonTransform.anchor.set(0.5, 1);
        this._salmonTransform.position.set(-5, 3);
        this._salmonTransform.hide();

        this._salmonLand = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.RING_LAND));
        this._salmonLand.anchor.set(0.5, 1);
        this._salmonLand.position.set(5, -8);
        this._salmonLand.hide();

        this._salmonContainer.addChild(this._salmonLand);
        this._salmonContainer.addChild(this._salmonJump);
        this._salmonContainer.addChild(this._salmonTransform);

        // rice
        this._riceContainer = new PIXI.Container();
        this._riceJump = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SYM_M4));
        this._riceJump.anchor.set(0.5, 1);
        this._riceJump.hide();

        this._riceTransform = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.SUSHI_TRANSFORM_NAME));
        this._riceTransform.anchor.set(0.5, 1);
        this._riceTransform.position.set(-5, 3);
        this._riceTransform.hide();

        this._riceLand = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(SymbolTransformAnimation.RING_LAND));
        this._riceLand.anchor.set(0.5, 1);
        this._riceLand.hide();

        this._riceContainer.addChild(this._riceLand);
        this._riceContainer.addChild(this._riceJump);
        this._riceContainer.addChild(this._riceTransform);


    }

    public reset() {
        this._soyTransform.hide();
        this._salmonTransform.hide();
        this._riceTransform.hide();
    }


    private createJumpSequence(jumpAnimation:TimelineSprite, ringAnimation:TimelineSprite):gsap.core.Timeline {
        let tl:gsap.core.Timeline =gsap.timeline();
        let duration:number = 0.56;
        tl.add(() =>{
            jumpAnimation.show();
            jumpAnimation.alpha = 1;
            jumpAnimation.position.y = -1000;
            jumpAnimation.scale.set(1,1);
        });
        tl.add([
            jumpAnimation.getAnimation([30, 0]),
            gsap.to(jumpAnimation, {
                duration:duration,
                x : 0,
                y : 0,
                ease : "power1.in"
            }),
        ]);
        tl.add([
            () => ringAnimation.show(),
            () => this.playLandingSound()
        ], "-=0.45");
        tl.add(ringAnimation.getAnimation(), "-=0.45");
        tl.add(() => ringAnimation.hide());
        return tl;

    }

    private createTransformSequence(jumpAnimation:TimelineSprite, transformAnimation:TimelineSprite, label:string):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(jumpAnimation, {duration:0.02, rotation : 0.1, ease : "none"}));
        tl.add(gsap.to(jumpAnimation, {duration:0.02, rotation : -0.1, ease : "none"}));
        tl.add(gsap.to(jumpAnimation, {duration:0.02, rotation : 0.1, ease : "none"}));
        tl.add(gsap.to(jumpAnimation, {duration:0.02, rotation : -0.1, ease : "none"}));
        tl.add(gsap.to(jumpAnimation, {duration:0.02, rotation : 0.0, ease : "none"}));

        tl.add(gsap.to(jumpAnimation.scale, {duration:0.1, x : 0.6, y : 1.2, ease : "none"}));
        tl.add([
            gsap.to(jumpAnimation.scale, {duration:0.05, x : 1.0, y : 0, ease : "none"}),
            gsap.to(jumpAnimation, {duration:0.05, alpha : 0, ease : "none"})
        ]);
        tl.add(() => jumpAnimation.hide());
        tl.add(() => {jumpAnimation.alpha = 1});
        tl.add(() => transformAnimation.show());
        tl.add(() => this.playTransformSound());
        tl.add(transformAnimation.getAnimation());
        return tl;
    }

    public getJumpAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(this.createJumpSequence(this._riceJump, this._riceLand));
        tl.add(this.createJumpSequence(this._salmonJump, this._salmonLand), "-=0.85");
        tl.add(this.createJumpSequence(this._soyJump, this._soyLand), "-=0.85");

        return tl;
    }

    public getTransformAnimation() {
        const tl:gsap.core.Timeline =  gsap.timeline();
        tl.add(this.createTransformSequence(this._soyJump, this._soyTransform, "Collect 3"));
        tl.add(this.createTransformSequence(this._riceJump, this._riceTransform, "Collect 6"), "-=0.7");
        tl.add(this.createTransformSequence(this._salmonJump, this._salmonTransform, "Collect 9"), "-=0.7");

        return tl;
    }

    private playTransformSound() {
        KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.TURN_INTO_WILD_SUSHI);
    }

    private playLandingSound() {
        KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOL_LANDING);
    }

}